import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

export const TIMEZONE = new InjectionToken<Observable<string>>('Timezone');
